import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/analytics'
import "firebase/performance";
import 'firebase/messaging';

var firebaseConfig = {
  // apiKey: "AIzaSyAa7NbkvcnmjQ2E8GMVr47dSBrBI1kjGXM",
  // authDomain: "chronicle-cloud-167518.firebaseapp.com",
  // databaseURL: "https://chronicle-cloud-167518.firebaseio.com",
  // projectId: "chronicle-cloud-167518",
  // storageBucket: "chronicle-cloud-167518.appspot.com",
  // messagingSenderId: "667932603706",
  // appId: "1:667932603706:web:2614cd1287caaf7c1d4c03",
  // measurementId: "G-CJMG2FFGGX"
  apiKey: "AIzaSyBAfgd7AUE3gxsssRPpfZutLjfOJhkHY4g",
  authDomain: "np-chr-dev-us-central-01.firebaseapp.com",
  projectId: "np-chr-dev-us-central-01",
  storageBucket: "np-chr-dev-us-central-01.firebasestorage.app",
  messagingSenderId: "85843772684",
  appId: "1:85843772684:web:40604aaddc95df424eb529",
  measurementId: "G-TG29VZKR9S"


  // apiKey: "AIzaSyCQbpqHXyH5Eqr57HpAMgQtB4MoCeBF6q4",
  // authDomain: "np-chr-stg-mgmt-01.firebaseapp.com",
  // projectId: "np-chr-stg-mgmt-01",
  // storageBucket: "np-chr-stg-mgmt-01.appspot.com",
  // messagingSenderId: "879480850061",
  // appId: "1:879480850061:web:fb26839a77e25ccdb644c4",
  // measurementId: "G-F7DEEJZXZE"
}
// Initialize Firebase

const firebaseAnalytics = firebase.initializeApp(firebaseConfig);
const firebaseSetProperties = firebase.analytics();
const perf = firebase.performance();
const storage = firebase.storage();
const auth = firebase.auth();
// const messaging = firebase.messaging();


let messaging = null;

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging()
}




const getToken = (setTokenFound) => {
  if (messaging && messaging?.getToken) {
    // return messaging.getToken({ vapidKey: 'BHWqeWRl3ReBgDgMNPVDPSIPyqyoyH0fjx8AV45CQ8VRl_xZ_ghuVr_oH3yyBfqsxn-XlN-6DohvUcPUPidNYDo' }
    // return messaging.getToken({ vapidKey: 'BHWqeWRl3ReBgDgMNPVDPSIPyqyoyH0fjx8AV45CQ8VRl_xZ_ghuVr_oH3yyBfqsxn-XlN-6DohvUcPUPidNYDo' }
    // {/* for dev*/}
    return messaging.getToken({ vapidKey: 'BMBKxTo5c3vX-kVk8HsJODD3A7h7vM78njtCPIayThCKP7U-ubqQzU5XYVdouGrBxLvM5jcFqnFK-SIc0ZlNAbs' }
    // {/* for stg*/}
    // return messaging.getToken({ vapidKey: 'BFx1v5wvk6EzP6iweM6WpGbJDs0CZFDBo3fCSCP4SyOUl17fpuxOp__lIyUiKBB6qGzPiP0DIsJwTIQJ_mEtEHE' }
    ).then((currentToken) => {
      if (currentToken) {
        console.log('current token for client: ', currentToken);
        sessionStorage.setItem("FBDeviceToken", currentToken)
        setTokenFound(true);
      } else {
        setTokenFound(false);
      }
    }).catch(() => {
    });
  } else {
    setTokenFound(false);
  }
}

const onMessageListener = () =>
  new Promise((resolve) => {
    messaging.onMessage((payload) => {
      resolve(payload);
    });
  });

export {
  storage, firebaseAnalytics, firebaseSetProperties, perf, getToken, messaging, onMessageListener, auth, firebase as default
}